import React from 'react'

function TenderTextSDL() {
  return (
    <embed src="\pdfs\EAT1.6.4.3_SD-L_Linear_Step_twist_outlet_kr.pdf" width="100%" height="2100px" />
  );
}

export default TenderTextSDL